const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-center');

export default [{
  path: '/expert/center',
  name: 'expert_center',
  component: Index,
  meta: {
    title: '个人中心',
    layout: 'center',
  },
}];



// WEBPACK FOOTER //
// ./src/pages/expert/center/index.js